/**
 * I ruoli, ridotti a quattro (28/10/2026). Lorenzo: "ci sono troppi permessi
 * comunque, non si capisce nulla, dobbiamo minimizzare". C'erano undici ruoli e
 * una tabella da 17 sezioni da cliccare casella per casella, e i ruoli in uso
 * erano due (Andrea e Lorenzo amministratori) più i due esterni.
 *
 * Ora ogni ruolo si dice in una frase. Cosa vede sezione per sezione resta nel
 * database, scritto una volta da prisma/fix-2026-10-28-ruoli.ts: non si tocca
 * più a mano. I ruoli vecchi non si cancellano: si vedono solo se qualcuno li ha
 * ancora, per poterlo spostare in uno dei quattro.
 */

/** I quattro ruoli, nell'ordine in cui si mostrano. */
export const RUOLI_PRINCIPALI = ['SUPER_ADMIN', 'COLLABORATORE', 'PROFESSIONISTA', 'AGENTE'] as const;

/** Cosa vede chi ha il ruolo, in una frase: la stessa in Impostazioni e in Nuovo utente. */
export const SPIEGA_RUOLO: Record<string, string> = {
  SUPER_ADMIN: 'Vede e fa tutto, compresi soldi, margini, amministrazione e impostazioni.',
  COLLABORATORE: "Chi lavora in Masamune: clienti, trattative, progetti e task. Non vede l'amministrazione, i margini e le impostazioni.",
  PROFESSIONISTA: "Esterno: vede solo le sue task, i progetti dove lavora e le scadenze, senza nessuna cifra. Segna a che punto è con ognuna.",
  AGENTE: "Esterno: vede solo le sue provvigioni, cioè i lavori e gli abbonamenti dei clienti che ha portato, cosa ha ricevuto e cosa deve ricevere. Poi collega l'utente alla sua scheda in Agenti.",
};

const posto = (key: string | null) => {
  const i = (RUOLI_PRINCIPALI as readonly string[]).indexOf(key ?? '');
  return i < 0 ? 99 : i;
};

/** I ruoli da mostrare: i quattro, più quelli vecchi che qualcuno ha ancora. */
export function ruoliVisibili<R extends { key: string | null; usersCount?: number }>(ruoli: R[] | undefined): R[] {
  return (ruoli ?? []).filter((r) => posto(r.key) < 99 || (r.usersCount ?? 0) > 0).sort((a, b) => posto(a.key) - posto(b.key));
}

/** I ruoli da dare a qualcuno: solo i quattro. */
export function ruoliAssegnabili<R extends { key: string | null }>(ruoli: R[] | undefined): R[] {
  return (ruoli ?? []).filter((r) => posto(r.key) < 99).sort((a, b) => posto(a.key) - posto(b.key));
}

export const ruoloVecchio = (key: string | null) => posto(key) === 99;
